import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { commonTexts } from 'consts/text';
import { getErrorMessageAndCode } from 'utils/errorHandlers/getErrorMessageAndCode';

export const nurseryRegistryInformationGetErrorParser: (
    error: unknown,
    defaultErrorMessage?: string,
) => string = (error, defaultErrorMessage = commonTexts.errorMessages.unknown) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.NURSERY_NOT_FOUND) {
        return commonTexts.errorMessages.nurseryRegistryNotFound;
    }

    return defaultErrorMessage;
};
